import { CATEGORIES } from '@/constants/categories';
import { cn } from '@/lib/utils';

// Ordem de exibição da barra da Home — mesmos value/label de CATEGORIES
// (nenhuma categoria nova, nenhum slug inventado aqui), só a ordem de
// apresentação pedida para essa barra específica.
const HOME_ORDER = [
  'musica', 'gastronomia', 'teatro', 'festival',
  'infantil', 'cultura', 'esportes', 'palestras', 'outros',
];

const HOME_CATEGORIES = HOME_ORDER
  .map((value) => CATEGORIES.find((c) => c.value === value))
  .filter(Boolean);

const PILLS = [{ label: 'Todos', value: null }, ...HOME_CATEGORIES];

// Filtro em memória, sem navegação — igual ao app Flutter: clicar numa
// categoria só troca o estado local (`active`) e re-renderiza a lista, sem
// trocar de rota, sem recarregar e sem mexer no scroll. `value: null`
// representa "Todos".
export function CategoryFilter({ active = null, onChange }) {
  return (
    // gap/padding menores só entre md e lg: nessa faixa os pills dividem a
    // linha com o título e o "Ver todos" (ver EventSection), então o
    // espaço é mais apertado. Fora dela (mobile com rolagem própria, e
    // desktop com mais espaço sobrando) volta ao espaçamento confortável.
    // min-w-0: sem isso, um flex item com overflow-x-auto não encolhe
    // abaixo do tamanho do próprio conteúdo (min-width:auto é o padrão do
    // flexbox) — o próprio scroll interno nunca entra em ação e a barra
    // empurra os irmãos (aqui, o "Ver todos" de EventSection) em vez de
    // rolar dentro do espaço que sobrou.
    <div className="min-w-0 w-full flex items-center gap-2.5 md:gap-1.5 lg:gap-2.5 overflow-x-auto scrollbar-hide -mx-1 px-1 py-1">
      {PILLS.map(({ label, value }) => {
        const isActive = active === value;
        return (
          <button
            key={value ?? 'todos'}
            type="button"
            onClick={() => onChange?.(value)}
            aria-pressed={isActive}
            className={cn(
              'flex-shrink-0 px-4 py-2 md:px-3 md:py-1.5 lg:px-4 lg:py-2 rounded-full text-sm font-medium whitespace-nowrap',
              'transition-colors duration-200',
              isActive
                ? 'bg-orange-500 text-white shadow-sm shadow-orange-500/25'
                : 'bg-muted/60 text-muted-foreground hover:bg-orange-50 hover:text-orange-600'
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
